import styled from 'styled-components';
import { LoadingMaskMixin } from '../../mixins/components/LoadingMaskMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledLoadingMask = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['display'])
}).withConfig({
  displayName: "StyledLoadingMask",
  componentId: "c11n-8-100-6__sc-1h8a6se-0"
})(["", ""], LoadingMaskMixin);